export default __webpack_public_path__ + "static/media/NQPHN-commissioned-services-map-icons_Mental Health.2423edcd.png";